import {useState, useEffect, useRef} from 'react'
import {useCustomMutation} from '@salesforce/commerce-sdk-react'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import useIsMobile from '../../../hooks/use-is-mobile'
import usedDeviceDetection from '../../../hooks/use-device-detection'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const SOURCE = {
    DESKTOPWEB: 'DESKTOPWEB',
    MOBILEWEB: 'MOBILEWEB'
}

const BRAND_ID = 'garage'

const notifyMe = () => {
    const isMobile = useIsMobile();
    const [isLoading, setIsLoading] = useState(false)
    const [source, setSource] = useState(SOURCE.DESKTOPWEB);
    const device = usedDeviceDetection()
    const {site, locale} = useMultiSite()
    // bodyRef is read lazily (via getter) after auth resolves, so it always
    // contains the values set synchronously just before mutateAsync is called.
    const bodyRef = useRef(null)

    useEffect(() => {
        setSource(isMobile ? SOURCE.MOBILEWEB : SOURCE.DESKTOPWEB);
    }, [isMobile]);

    const mutation = useCustomMutation({
        options: {
            method: 'POST',
            parameters: {
                siteId: site?.id,
                locale: locale?.id
            },
            // getter ensures the body string is read after auth.ready() resolves,
            // by which time bodyRef.current is already populated.
            get body() {
                return bodyRef.current
            },
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: '/notify-me',
                apiName: 'notify-me'
            }
        }
    })

    const submitNotifyMe = async ({formData, shouldFetch = true, subscriptionSource}) => {
        if (!shouldFetch) return

        let data

        setIsLoading(true)

        try {
            const form = JSON.parse(formData)

            // Set body synchronously before mutateAsync so the getter picks it up
            bodyRef.current = JSON.stringify({
                brandId: BRAND_ID,
                source: source,
                sku: form?.notifyMeSKU,
                email: form?.notifyMeEmail,
                device: device,
                ...(subscriptionSource && {subscriptionSource})
            })

            data = await mutation.mutateAsync({})
        } catch (error) {
            logger.error('Error submitting notify me', {
                namespace: 'notify-me',
                additionalProperties: {error: error.message, stack: error.stack}
            })
        } finally {
            setIsLoading(false)
        }

        return data
    }

    return {
        isLoading,
        submitNotifyMe
    }
}

export {notifyMe}
